export enum DisciplinaryCaseStates {
  Open = 'Open',
  Closed = 'Closed',
}

export const DisciplinaryCaseStateMap: { [key: string]: string } = {
  [DisciplinaryCaseStates.Open]: 'Open',
  [DisciplinaryCaseStates.Closed]: 'Closed',
}
